import { $_DKD, $_GCD, $_CD } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";
import gripUtil from "@/libs/grip.util";

export default {
    state: {
        promiseFieldCodeList: [],
        smartFieldCodeList: [],
        selectedArchivingTab: 'promise',
        // selectedArchivingTab: 'smart',
        selectedArchiving: {},
        bizList: [],
        promiseList: [],
        majorList: [],
        smartList: [],
        majorMap:{},
        majorUpperMap:{},
        promiseMap:{},
        smartMap:{},
        promiseInfoMap: {
            // 1: {
            //     dataSeq: '혁신성장',
            //     title: '살기 편한 친환경',
            //     desc: '사람 중심의 지속가능한<br />스마트도시 강남',
            //     clazz: ['major_box', 'm_box_01', 'skyblue'],
            //     subClazz: ['prom_listbox', 'skyblue', 'swiper-container'],
            //     chartid: 396,
            // },
            // 2: {
            //     dataSeq: '문화생태',
            //     title: '구민과 함께 소통하는',
            //     desc: 'K-culture 허브도시,<br />일상 속 푸른 강남',
            //     clazz: ['major_box', 'm_box_04', 'red'],
            //     subClazz: ['prom_listbox', 'red', 'swiper-container'],
            //     chartid: 399,
            // },
            // 3: {
            //     dataSeq: '안심행복',
            //     title: '구민과 함께 소통하는',
            //     desc: '편안한 삶을 영위하는<br />모두가 안전한 강남',
            //     clazz: ['major_box', 'm_box_04', 'red'],
            //     subClazz: ['prom_listbox', 'red', 'swiper-container'],
            //     chartid: 399,
            // },
            // 4: {
            //     dataSeq: '공감동행',
            //     title: '미래의 자생력을 키우는',
            //     desc: '세대·계층 포용하며<br />동행하는 강남',
            //     clazz: ['major_box', 'm_box_02', 'orange'],
            //     subClazz: ['prom_listbox', 'orange', 'swiper-container'],
            //     chartid: 397,
            // },
            // 5: {
            //     dataSeq: '초(超)밀착',
            //     title: '다양성이 존중받는',
            //     desc: '주민이 주인되는 가치<br />실현, 소통 강남',
            //     clazz: ['major_box', 'm_box_03', 'green'],
            //     subClazz: ['prom_listbox', 'green', 'swiper-container'],
            //     chartid: 398,
            // },
        },
        smartInfoMap: {
            // 1: {
            //     dataSeq:'살기 편한 강남',
            //     title:'살기 편한 강남',
            //     subTitle:['민원행정'],
            //     desc: '인공지능, loT 등 스마트기술을 활용하여 구민의 안전을 보장하고 각종 재난 및 교통사고 등의 예방과 신속한 대응체계를 확보',
            //     clazz: ['smart_box', 'm_box_04', 'red'],
            //     subClazz: ['prom_listbox', 'red', 'swiper-container'],
            //     chartid:599,
            // },
            // 2: {
            //     dataSeq:'포용 하는 강남',
            //     title: '포용 하는 강남',
            //     subTitle:['복지', '보건', '환경'],
            //     desc:'어르신, 장애인 등 사회적 약자를 위한 스마트 돌봄, 환경, 헬스케어 등 스마트서비스 제공',
            //     clazz: ['smart_box', 'm_box_02', 'orange'],
            //     subClazz: ['prom_listbox', 'orange', 'swiper-container'],
            //     chartid:597,
            // },
            // 3: {
            //     dataSeq:'찾고 싶은 강남',
            //     title: '찾고 싶은 강남',
            //     subTitle:['교통', '방범', '방재'],
            //     desc:'4차산업 기술 기반 수서·세곡 로봇 친화 도시 조성 및 도심 속 휴식 공간 제공 등 다양한 스마트서비스 제공으로 찾고 싶은 미래형 매력도시 강남 구현',
            //     clazz: ['smart_box', 'm_box_01', 'skyblue'],
            //     subClazz: ['prom_listbox', 'skyblue', 'swiper-container'],
            //     chartid:596,
            // },
            // 4: {
            //     dataSeq:'소통하는 강남',
            //     title: '소통하는 강남',
            //     subTitle:['문화','관광'],
            //     desc:'주요 데이터를 연계⦁통합관리하여 구민과 공유하고, 다양한 프로그램, 참여 네트워크 운영으로 시민역량 확대 및 디지털 격차 해소',
            //     clazz: ['smart_box', 'm_box_03', 'green'],
            //     subClazz: ['prom_listbox', 'green', 'swiper-container'],
            //     chartid:598,
            // },
        },
        majorInfoTxt: {
            '32201190000': {
                title:'행정국',
                desc:'주민 중심 민원행정서비스, 고품격 평생학습도시 조성으로<br />경쟁력 있는 인재육성, 품격 있는 서비스 행정을 실현하겠습니다.'
            },
            '32202420000': {
                title:'기획경제국',
                desc:'안정적 서민경제 지원, 청년의 자립지원 확대, 신뢰세정 구현으로<br />전략적 재정 관리 및 지역경제 활성화를 실현하겠습니다.'
            },
            '32202230000': {
                title:'복지생활국',
                desc:'어르신 복지환경 조성, 저출산 대응기반 구축, 취약계층 수요자 중심의<br />포용 복지 실현으로 모두가 행복한 도시 강남을 구현하겠습니다.'
            },
            '32202590000': {
                title:'미래문화국',
                desc:'로봇거점지구와 스마트 미래도시 조성, 새로운 문화가치 창출로<br />강남다운 라이프스타일 도시, 매력도시 강남을 구현하겠습니다.'
            },
            '32201580000': {
                title:'도시환경국',
                desc:'맑고 깨끗한 푸른 강남, 미래 지향적인 명품 도시건설로<br />필 환경도시, 품격 있는 주거환경을 조성하겠습니다.'
            },
            '32201970000': {
                title:'안전교통국',
                desc:'쾌적한 보행환경 조성, 재해예방, 주민 공감 주차환경 조성으로<br />안전하고 편리한 미래 강남을 건설하겠습니다.'
            },
            '32200330000': {
                title:'보건소',
                desc:'감염병 위기 대응, 민관 연계・협력을 통한 건강안전망 구축으로<br />모두가 차별 없이 건강을 누리는 강남을 구현하겠습니다.'
            },
            '32202150000': {
                title:'정책홍보실',
                desc:''
            },
            '32201080000': {
                title:'감사담당관',
                desc:''
            },
            '32202560000': {
                title:'중대재해예방실',
                desc:''
            },
            '32202730000': {
                title:'미래전략기획단',
                desc:''
            },
        },
        bizDetailList:[],
        bizHistoryList: [],
        bizDetail: {},
        dispBizTab: [],
        showBizTop: false,
        clazzCate: [],
    },
    getters: {
        getPromiseFieldCodeList(state) {
            return state.promiseFieldCodeList;
        },
        getSmartFieldCodeList(state) {
            return state.smartFieldCodeList;
        },
        getSelectedArchivingTab(state) {
            return state.selectedArchivingTab;
        },
        getSelectedArchiving(state) {
            return state.selectedArchiving;
        },
        getBizList(state) {
            return state.bizList;
        },
        getPromiseList(state) {
            return state.promiseList;
        },
        getMajorList(state) {
            return state.majorList;
        },
        getSmartList(state) {
            return state.smartList;
        },
        getMajorMap(state) {
            return state.majorMap;
        },
        getMajorUpperMap(state) {
            return state.majorUpperMap;
        },
        getPromiseMap(state) {
            return state.promiseMap;
        },
        getSmartMap(state) {
            return state.smartMap;
        },
        getPromiseInfoMap(state) {
            return state.promiseInfoMap;
        },
        getSmartInfoMap(state) {
            return state.smartInfoMap;
        },
        getMajorInfoTxt(state) {
            return state.majorInfoTxt;
        },
        getBizHistoryList(state) {
            return state.bizHistoryList;
        },
        getBizDetail(state) {
            return state.bizDetail;
        },
        getDispBizTab(state) {
            return state.dispBizTab;
        },
        getShowBizTop(state) {
            return state.showBizTop;
        },
        getClazzCate(state) {
            return state.clazzCate;
        },
    },
    mutations: {
        PROMIMSE_FIELD_CODE_LIST(state, promiseFieldCodeList) {
            state.promiseFieldCodeList = promiseFieldCodeList;
        },
        SMART_FIELD_CODE_LIST(state, smartFieldCodeList) {
            state.smartFieldCodeList = smartFieldCodeList;
        },
        SELECTED_ARCHIVING_TAB(state, selectedArchivingTab) {
            state.selectedArchivingTab = selectedArchivingTab;
        },
        SELECTED_ARCHIVING(state, selectedArchiving) {
            state.selectedArchiving = selectedArchiving;
        },
        BIZ_LIST(state, bizList) {
            state.bizList = bizList;
        },
        PROMISE_LIST(state, promiseList) {
            state.promiseList = promiseList;
        },
        MAJOR_LIST(state, majorList) {
            state.majorList = majorList;
        },
        SMART_LIST(state, smartList) {
            state.smartList = smartList;
        },
        MAJOR_MAP(state, majorMap) {
            state.majorMap = majorMap;
        },
        MAJOR_UPPER_MAP(state, majorUpperMap) {
            state.majorUpperMap = majorUpperMap;
        },
        PROMISE_MAP(state, promiseMap) {
            state.promiseMap = promiseMap;
        },
        SMART_MAP(state, smartMap) {
            state.smartMap = smartMap;
        },
        MAJOR_INFO_TXT(state, majorInfoTxt) {
            state.majorInfoTxt = majorInfoTxt;
        },
        BIZ_HISTORY_LIST(state, bizHistoryList) {
            state.bizHistoryList = bizHistoryList;
        },
        BIZ_DETAIL(state, bizDetail) {
            state.bizDetail = bizDetail;
        },
        PROMISE_INFO_MAP(state, promiseInfoMap) {
            state.promiseInfoMap = promiseInfoMap;
        },
        SMART_INFO_MAP(state, smartInfoMap) {
            state.smartInfoMap = smartInfoMap;
        },
        DISP_BIZ_TAB(state, dispBizTab) {
            state.dispBizTab = dispBizTab;
        },
        SHOW_BIZ_TOP(state, showBizTop) {
            state.showBizTop = showBizTop;
        },
        CLAZZ_CATE(state, clazzCate) {
            state.clazzCate = clazzCate;
        },
    },
    actions: {
        // 보류
        FETCH_PROMIMSE_FIELD_CODE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_GCD.PROMISE_FIELD)
            .then(res => {
                commit('PROMIMSE_FIELD_CODE_LIST', res.data.data);
            })
        },
        FETCH_SMART_FIELD_CODE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_GCD.SMART_FIELD)
            .then(res => {
                commit('SMART_FIELD_CODE_LIST', res.data.data);
            });
        },
        SET_SELECTED_ARCHIVING_TAB({commit}, selectedArchivingTab) {
            commit('SELECTED_ARCHIVING_TAB', selectedArchivingTab);
        },
        SET_SELECTED_ARCHIVING({commit}, archiving) {
            commit('SELECTED_ARCHIVING', archiving);
        },
        FETCH_BIZ_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.BIZ_LIST)
            .then(res => {
                commit("BIZ_LIST", res.data.data);
            })
        },

        SET_PROMISE_LIST({commit}, promiseList) {
            commit('PROMISE_LIST', promiseList);
        },
        SET_MAJOR_LIST({commit}, majorList) {
            commit('MAJOR_LIST', majorList);
        },
        SET_SMART_LIST({commit}, smartList) {
            commit('SMART_LIST', smartList);
        },
        SET_MAJOR_MAP({commit}, major_map) {
            commit('MAJOR_MAP', major_map);
        },
        SET_MAJOR_UPPER_MAP({commit}, majorUpperMap) {
            commit('MAJOR_UPPER_MAP', majorUpperMap);
        },
        SET_PROMISE_MAP({commit}, promiseMap) {
            commit('PROMISE_MAP', promiseMap);
        },
        SET_SMART_MAP({commit}, smartMap) {
            commit('SMART_MAP', smartMap);
        },
        FETCH_BIZ_HISTORY_LIST({commit}, seq) {
            let q = 'val1='+seq;
            return commonApi.fetchRepoDataListWithCodeName($_DKD.BIZ_HISTORY_LIST, q)
            .then(res => {
                commit('BIZ_HISTORY_LIST', res.data.data);
            })
        },
        FETCH_BIZ_DETAIL({commit}, seq) {
            let q = 'val1='+seq;
            return commonApi.fetchRepoDataListWithCodeName($_DKD.BIZ_HISTORY_LIST, q)
            .then(res => {
                let list = res.data.data;
                //val1이 키 이지만 중복값이 존재 하는 경우가 있음..
                list = list.sort(function(cur, pre) {
                    return cur.basdtVal > pre.basdtVal ? -1 : cur.basdtVal < pre.basdtVal ? 1 : 0;
                })
                list = list.sort(function(cur, pre) {
                    return cur.val16 > pre.val16 ? -1 : cur.val16 < pre.val16 ? 1 : 0;
                })
                if(list.length > 0) {
                    commit('BIZ_DETAIL', list[0]);
                }
            })
        },
        FETCH_PROMISE_INFO_MAP({commit}) {
            return commonApi.fetchMaxDataListWithCodeName($_DKD.BIZ_PROMISE_CATE, 'basdt_val')
            .then(res => {
                // console.log('504', res.data.data);
                let infoMap = {};
                let promiseCate = res.data.data;
                promiseCate.forEach(d => {
                    let clazz = d.val4.split(',');
                    let subClazz = d.val5.split(',');
                    if(typeof infoMap[d.val1] === 'undefined') {
                        infoMap[d.val1] = {
                            dataSeq: d.valNm1,
                            title: d.val2,
                            desc: d.val3,
                            clazz: clazz,
                            subClazz: subClazz,
                            chartid: Number(d.val6),
                        }
                    }
                });
                // console.log('infoMap', infoMap);
                commit('PROMISE_INFO_MAP', infoMap);
            });
        },
        FETCH_SMART_INFO_MAP({commit}) {
            return commonApi.fetchMaxDataListWithCodeName($_DKD.BIZ_SMART_CATE, 'basdt_val')
            .then(res => {
                // console.log('506', res.data.data);
                let infoMap = {};
                res.data.data.forEach(d => {
                    if(typeof infoMap[d.val1] === 'undefined') {
                        let subTitle = d.val3.split(',');
                        let clazz = d.val5.split(',');
                        let subClazz = d.val6.split(',');
                        // console.log('clazz', clazz);
                        infoMap[d.val1] = {
                            dataSeq: d.valNm1,
                            title: d.val2,
                            subTitle: subTitle,
                            desc: d.val4,
                            clazz: clazz,
                            subClazz: subClazz,
                            chartid: Number(d.val7),
                        }
                    }
                });
                // console.log('infoMap', infoMap);
                commit('SMART_INFO_MAP', infoMap);
            });
        },
        FETCH_DISP_BIZ_TAB({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.BIZ_TAB)
                .then(res => {
                    let list = res.data.data;
                    let showBizTop = false;
                    list = list.sort((pre, cur) => {
                        return Number(pre.val3) > Number(cur.val3) ? 1 : Number(pre.val3) < Number(cur.val3) ? -1 : 0;
                    });
                    // console.log('list', list);
                    let yList = [];
                    list.forEach(d => {
                        if(d.val2 === 'Y') {
                            showBizTop = true;
                            yList.push(d);
                        }
                    });
                    if(yList.length > 0) {
                        commit('SELECTED_ARCHIVING_TAB', yList[0].val1);
                    }
                    commit('SHOW_BIZ_TOP', showBizTop);
                    commit('DISP_BIZ_TAB', yList);
                });
        },
        FETCH_CLAZZ_CATE({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_CD.CLAZZ_CATEGORY)
                .then(res => {
                    let list = res.data.data.filter(d => {
                        return d.useYn === true;
                    });
                    // console.log('list', list);
                    commit('CLAZZ_CATE', list);
                });
        },
    },
}
